import type { AppContext } from '@application/context/AppContext';

/**
 * Le module fin est-il livré à cette entreprise ? Refus fermé si aucune licence n'est chargée.
 * Sert à brancher les modules qui n'ouvrent pas d'écran dédié (devises, passerelle paie-compta).
 */
export function isModuleLicensed(ctx: AppContext, code: string): boolean {
  return ctx.getLicenceRuntime()?.featureGate.has(code) ?? false;
}

/**
 * Le module fin est-il explicitement ABSENT de la licence chargée ? Contrairement à `isModuleLicensed`
 * (refus fermé), sans licence chargée la réponse est « non » : sert à ne pas appeler un module non souscrit
 * (offre Paie seule) sans changer le comportement quand aucune licence n'est encore connue.
 */
export function isModuleExcluded(ctx: AppContext, code: string): boolean {
  const runtime = ctx.getLicenceRuntime();
  return runtime ? !runtime.featureGate.has(code) : false;
}

export const PAIE_COMPTA_MODULE = 'paie_comptabilite';
export const DEVISES_MODULE = 'devises';

export const PAIE_COMPTA_NOT_LICENSED_MESSAGE =
  'La passerelle paie-comptabilité n’est pas incluse dans votre licence.';
export const DEVISES_NOT_LICENSED_MESSAGE =
  'La gestion des devises n’est pas incluse dans votre licence.';
